<template>
    <div class="modalDialog is-active" name="unionSchedule " role="dialog" aria-labelledby="modal-title" aria-describedby="modal-description" aria-hidden="true" @keyup.esc="closeModal">
        <div class="modal-contents wide">
            <div>
                <a title="Close" class="close" @click="closeModal">X</a>
                <h3><slot id="modal-title" name="header">
                    Union Schedule<br />Week Ending {{ weekEndingShort }}
                </slot></h3>
                <hr />
            </div>
            <div>
                <slot id="modal-description" name="body">
                    <div class="col-sm-2"><label style="float: left">Location</label></div>
                    <div class="col-sm-10">
                        <select class="form-control" name="selectedLocation" v-model="selectedLocation" placeholder="Location" @change="refreshSchedule(entityId, selectedLocation)">
                            <option v-for="(location, index) in locations" 
                                :key="index"
                                :value="location.id"
                                :selected="location.id == selectedLocation"
                            >{{ location.name }}</option>
                        </select>
                    </div>
                    <div class="clear"></div>
                    <div class="col-sm-2"><label style="float: left">Date</label></div>
                    <div class="col-sm-2 timecard centered">
                        <div class="col-xs-6 centered">
                            <label style="float: none;">Call</label>
                        </div>
                        <div class="col-xs-6">
                            <label style="float: none;">Wrap</label>
                        </div>
                    </div>
                    <div class="col-sm-4 timecard centered">
                        <div class="col-xs-3">
                            <label style="float: none;">Shoot Day</label>
                        </div>
                        <div class="col-xs-3">
                            <label style="float: none;">Breakfast</label>
                        </div>
                        <div class="col-xs-3">
                            <label style="float: none;">Grace</label>
                        </div>
                        <div class="col-xs-3">
                            <label style="float: none;">Wrap</label>
                        </div>
                    </div>
                    <div class="col-sm-4 timecard centered">
                        <div class="col-xs-6">
                            <label style="float: none;">Meal 1 Time</label>
                        </div>
                        <div class="col-xs-6">
                            <label style="float: none;">Walking 2nd Meal</label>
                        </div>
                    </div>
                    <div v-for="date in dates" :key="date.date + date.id">
                        <union-schedule-entry :name="date.date" :entity-id="entityId" :dateObject="date" @updateTime="updateTime" @updateOption="updateSchedule" :tzoffset="tzoffset">
                        </union-schedule-entry>
                    </div>
                </slot>
                <hr />
            </div>
            <div class="right">
                <slot name="footer">
                    <span class="btn btn-danger m-right-10 bold" @click="importTimes">Import into Timecard</span>
                    <span class="btn btn-warning m-right-10 bold" @click="getPreviousWeek">Previous Week</span>
                    <span class="btn btn-success m-right-20 bold" @click="getNextWeek">Next Week</span>
                    <span class="btn btn-primary bold" @click="saveSchedule">Save</span>
                </slot>
            </div>
            <div class="clear"></div>
        </div>
    </div>
</template>

<script>
import unionScheduleEntry from '../components/unionScheduleEntry.vue';
import TimecardMixin from '../mixins/TimecardMixin';
import {DateTime} from 'luxon';
import {defineComponent} from 'vue';

export default defineComponent ({
    emits: ['import-schedule', 'close', 'modal-confirm'],
    components: {
        unionScheduleEntry,
    },

    mixins: [ TimecardMixin ],

    props: {
        entityId: {
            type: Number,
            required: true
        },
        locationId: {
            type: Number,
            required: true
        },
        weekEnding: {
            type: String || Date,
            required: true
        },
        location: {
            type: Object,
            required: false
        },
        locations: {
            type: Array,
            required: true
        },
        api: {
            type: Object,
            required: true
        },
        tzoffset: {
            type: Number,
            required: false
        },
        format: {
            type: String,
            required: false,
            default: 'MM/dd/yyyy'
        },
    },

    data() {
        return {
            curWeekEnding: this.weekEnding,
            dates: [],
            selectedLocation: [],
        }
    },

    computed: {
        weekEndingShort () {
            if (! this.curWeekEnding) return [];
            return this.curWeekEnding;
        }
    },

    watch: {
        curWeekEnding (newWeekEnding) {
            newWeekEnding = DateTime.fromFormat(newWeekEnding, this.format).toFormat('MM/dd/yyyy');
            this.refreshSchedule(this.entityId, this.locationId, newWeekEnding);
        }

    },

    methods: {
        importTimes () {
            this.$emit('import-schedule', this.dates)
        },

        getPreviousWeek () {
            const tempDate = DateTime.fromFormat(this.curWeekEnding, this.format).plus({day: -7}).toFormat(this.format);
            this.curWeekEnding = tempDate;
        },

        getNextWeek () {
            const tempDate = DateTime.fromFormat(this.curWeekEnding, this.format).plus({day: 7}).toFormat(this.format);
            this.curWeekEnding = tempDate;
        },

        updateSchedule (options) {
            if (!options || !options.hasOwnProperty('date')) return false;

            let day = this.dates.find(({ date }) => date === options.date);
            day[options.name] = options.value === true ? 1 : 0;
        },

        updateTime (options) {
            if (!options || !options.hasOwnProperty('date')) return false;

            let day = this.dates.find(({ date }) => date === options.date);
            day[options.name] = options.value;
        },

        saveSchedule () {
            let promises = [];
            for (const i in this.dates) {
                let dateObject = this.dates[i];
                if (! dateObject.date) continue;
                let method = 'post';
                let endpoint = '/unionschedule/' + this.entityId + '/' + this.locationId + '/' + dateObject.date;

                if (dateObject.hasOwnProperty('id') && dateObject.id) {
                    method = 'patch';
                }

                // promises.push(this.api[method](endpoint, dateObject));
                this.api[method](endpoint, dateObject)
                    .then(response => {
                        if (response.status === 201) {
                        this.dates[i].id = response.data.results.id || null;
                        }
                    });
            }
            this.closeModal();
        },
        closeModal (event) {
            this.$emit('close');
        },
        confirmModal () {
            this.$emit('modal-confirm');
            this.closeModal();
        },
        pad (n) {
            return n<10 ? '0'+n : n;
        },
        log (message) {
            console.log('Log');
            console.log(message);
        }
    },

    mounted () {
        this.selectedLocation = this.locationId;
        this.refreshSchedule(null,null,DateTime.fromFormat(this.curWeekEnding, this.format).toFormat('MM/dd/yyyy'));
    }
});
</script>

<style>
.wide { width: 90%; max-width: 975px; }
</style>